"use strict";

import client from "./client";

const getRequest = (path, params) => {
    return new Promise((resolve, reject) => {
        client({
            method: "GET",
            path: path,
            params: params,
        })
        .catch(reject)
        .done(response => {
            resolve(response);
        });
    });
};

const postRequest = (path, entity) => {
    return new Promise((resolve, reject) => {
        client({
            method: "POST",
            path: path,
            entity: entity,
        })
        .catch(reject)
        .done(response => {
            resolve(response);
        });
    });
};

export {
    getRequest,
    postRequest,
};
